import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import DirectoryModal from "../directory-modal/directoryModal";
import "../directory-modal/directoryModal";
import Follows from "../follows/follows";

import "./cardContact.scss";

const CardContact = (props: ReferenciaContenido) => {
  const { tituloGeneral, referenciaPlantillaContenido } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const data = useStaticQuery(graphql`
    query HELP_CENTER_CONTACT {
      allContentfulFooter(filter: { titulo: { eq: "Footer bibliotecas" } }) {
        nodes {
          titulo
          categorias {
            nombreCategoria
            referenciaSubcategorias {
              titulo
              slug
              link
              nombreSubcategoria
              tipoCampo
            }
          }
        }
      }
    }
  `);

  const callText = [
    referenciaPlantillaContenido[0].tituloBanner,
    referenciaPlantillaContenido[0].tituloDescripcion,
    ...referenciaPlantillaContenido[0].tipoTitulo.split("/"),
  ];
  const followText = [
    referenciaPlantillaContenido[1].tituloBanner,
    referenciaPlantillaContenido[1].tituloDescripcion,
  ];

  return (
    <section className="m-card-contact__container">
      <h2 className="m-card-contact__container-title">{tituloGeneral}</h2>
      <div className="m-card-contact__container-card">
        <div className="m-card-contact__container-card__column">
          <div className="m-card-contact__container-card__column-title">
            <span className="icon-call-telephone" />
            <h3>{callText[0].trim()}</h3>
          </div>
          <div className="m-card-contact__container-card__column-content">
            <p>{callText[1].trim()}</p>
            <div className="m-card-contact__container-card__column-content__phone">
              <span>{callText[2].trim()}</span>
              <a title={callText[3].trim()} href={`tel: ${callText[3].trim()}`} rel="nofollow noreferrer">
                <i className="icon-phone" /> {callText[3].trim()}
              </a>
            </div>
            <div className="m-card-contact__container-card__column-content__phone">
              <span>{callText[4].trim()}</span>
              <a href="#" onClick={() => setIsModalOpen(true)} rel="nofollow noreferrer">
                {callText[5].trim()}
              </a>
            </div>
          </div>
        </div>
        <div className="m-card-contact__container-card__separator"></div>
        <div className="m-card-contact__container-card__column">
          <div className="m-card-contact__container-card__column-title">
            <span className="icon-give-heart" />
            <h3>{followText[0].trim()}</h3>
          </div>
          <div className="m-card-contact__container-card__column-content">
            <p>{followText[1].trim()}</p>
            <div className="m-card-contact__container-card__column-content__social">
              <Follows
                query={data.allContentfulFooter.nodes[0].categorias[8]}
                inverse
                noTitle
              />
            </div>
          </div>
        </div>
      </div>
      <DirectoryModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default CardContact;
